import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Grid from "@mui/material/Grid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  clearApiStatus,
  getAuditTrailList,
} from "../redux/administrator/actions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./auditTable.scss";
import SearchBar from "./Controls/SearchBar/SearchBar";
import { Select, MenuItem } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import TableSkeleton from "../components/Skeletons/TableSkeleton";
import { adminRoutes } from "../routes/routeConstants";

function Row(props) {
  const { project } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const viewProjectOrBatchHistory = (payload) => {
    const data = {
      payload: payload,
      data: payload.data,
    };
    navigate(`/${adminRoutes.dataHistory}`, {
      state: data,
    });
  };

  return (
    <React.Fragment>
      <Grid key={project?.project_id} container className="table-data">
        <Grid item sm={1}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Grid>
        <Grid item sm={4} className="break-word">
          {project?.project_name}
        </Grid>
        <Grid item xs={3}></Grid>

        <Grid item xs={2} className="text-center padd-5">
          {" "}
          <IconButton
            onClick={() =>
              viewProjectOrBatchHistory({
                projectId: project?.project_id,
                isProjectHistory: true,
              })
            }
          >
            <VisibilityIcon />
          </IconButton>
        </Grid>
      </Grid>

      <Box>
        {open &&
          project.batch_details.map((batch, i) => (
            <Grid
              container
              className="hidden-row"
              spacing={2}
              key={batch?.batch_id}
            >
              <Grid item sm={1} className="break-word"></Grid>

              <Grid item sm={4} className="break-word"></Grid>
              <Grid item sm={3} className="text-center padd-5">
                {batch.batch_name}
              </Grid>

              <Grid item xs={2} className="text-center padd-5">
                <IconButton
                  onClick={() =>
                    viewProjectOrBatchHistory({
                      projectId: batch?.project_id,
                      batchId: batch?.batch_id,
                      isBatchHistory: true,
                      data: batch,
                    })
                  }
                >
                  <VisibilityIcon />
                </IconButton>
              </Grid>
            </Grid>
          ))}
      </Box>
    </React.Fragment>
  );
}

export default function DataTable(records, headCells, props) {
  const dispatch = useDispatch();
  const [projects, setProjects] = useState([]);
  const auditlist = useSelector((state) => state?.admin?.auditData);
  const apiStatus = useSelector((state) => state?.admin?.apiStatus);

  const navigate = useNavigate();
  const type = useSelector((state) => state?.prePro?.type);
  const [activityName, setActivityName] = useState("Data History");
  const activity = [
    {
      id: "1",
      name: "User Activity",
    },
    { id: "2", name: "Data History" },
  ];
  const [pageCount
    // , setPageCount
  ] = useState(auditlist?.total_count || 0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(0);

  useEffect(() => {
    dispatch(clearApiStatus());
    dispatch(
      getAuditTrailList({
        page: page + 1,
        page_size: rowsPerPage,
        type: "",
        formattedStartDate: "",
        formattedEndDate: "",
        status: "",
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, rowsPerPage]);

  useEffect(() => {
    setProjects(auditlist?.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  useEffect(() => {
    if (auditlist?.data?.length > 0) {
      setProjects(auditlist?.data);
    }
  }, [auditlist?.data]);

  const onSearch = (word, type) => {
    let result;
    let filteredProjects = [];

    if (!auditlist?.data || !Array.isArray(auditlist.data)) {
      setProjects([]);
      return;
    }

    if (type === "project") {
      if (word) {
        result = auditlist?.data?.filter(function (el) {
          return (
            el?.project_name
              .toString()
              .toLowerCase()
              .indexOf(word.toLowerCase()) !== -1
          );
        });
      } else {
        result = auditlist?.data;
      }
    } else {
      if (word) {
        auditlist?.data?.map((item, index) => {
          const filteredBatches = item?.batch_details?.filter(function (el) {
            return (
              el?.batch_name
                .toString()
                .toLowerCase()
                .indexOf(word.toLowerCase()) !== -1
            );
          });
          if (filteredBatches.length > 0) {
            filteredProjects.push({
              ...auditlist?.data[index],
              batch_details: filteredBatches,
            });
          } else {
          }
        });
        result = filteredProjects;
      } else {
        result = auditlist?.data;
      }
    }
    setProjects(result);
  };

  const showUserActivity = (value) => {
    setActivityName(value);
    if (value === "User Activity") {
      navigate( `/${adminRoutes.auditUserActivity}`)
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    dispatch(
      getAuditTrailList({
        page_size: rowsPerPage,
        page: value + 1,
      })
    );
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  return (
    <>
      {apiStatus?.loader ? (
        <TableSkeleton />
      ) : (
        <div className="action-wrap-outer">
          <Grid container className="action-wrap">
            <Grid item md={4}>
              <SearchBar onSearch={(value, type) => onSearch(value, type)} />
            </Grid>
            <Grid item className="action-select-wrap" md={2}>
              <Select
                className="input-drop-select"
                labelId="demo-simple-select-autowidth-label"
                id="demo-simple-select-autowidth"
                value={activityName}
                size="small"
                onChange={(event) => showUserActivity(event.target.value)}
                fullWidth
              >
                {activity?.map((index) => {
                  return (
                    <MenuItem
                      key={index?.name}
                      value={index?.name}
                      selected={true}
                    >
                      {index?.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </Grid>
          </Grid>
          <Box className="Audit-table-wrap">
            <Grid container className="tableHeader">
              <Grid item xs={1}></Grid>
              <Grid item xs={4}>
                Project Name
              </Grid>
              <Grid item xs={3} className="text-center padd-5">
                Batch Name
              </Grid>

              <Grid item xs={2} className="text-center padd-5">
                History
              </Grid>
            </Grid>

            {projects &&
              projects.length > 0 &&
              projects?.map((project, i) => (
                <Row
                  key={project?.project_id}
                  project={project}
                  i={i}
                  props={props}
                />
              ))}
          </Box>
          {projects && projects.length > 0 && (
            <TablePagination
              component="div"
              rowsPerPageOptions={[100, 200, 300, 500]}
              count={parseInt(pageCount)}
              page={parseInt(page)}
              onPageChange={handlePageChange}
              rowsPerPage={parseInt(rowsPerPage)}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </div>
      )}
    </>
  );
}
